var r, a;
function i() {
  if (a) return r;
  a = 1;
  var e = Array.isArray;
  return r = e, r;
}
export {
  i as __require
};
